// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, VALID, onlyWhenSupport } from '@tectonics/prs/validation';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import {
  getCurrentPaymentMethodOptionalFields,
  hasOptionalField,
} from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import { shouldDisabledCustomerNameField } from '@tectonics/prs/ui/get-disabled-customer-name-field';
import { validateMalaysianDuitNowBankCode } from '@tectonics/prs/malaysia/validation/malaysian-duitnow-bank-code';
import { validateMalaysianCustomerName } from '@tectonics/prs/malaysia/validation/malaysian-customer-name';
import { validateMalaysianCustomerEmail } from '@tectonics/prs/malaysia/validation/malaysian-customer-email';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  const optionalFields = incomingPayment.status === 'OP'
    ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec)
    : [];
  // A readonly name comes from the merchant and cannot be fixed by the customer.
  const isReadonlyCustomerName = incomingPayment.status === 'OP'
    && shouldDisabledCustomerNameField(incomingPayment);

  switch (userInputName) {
    case 'selectedBankCode':
      return validateMalaysianDuitNowBankCode(
        userInputValues.selectedPaymentMethod,
        userInputValues.selectedEWallet,
        userInputValues.selectedBankCode
      );

    case 'customerName':
      if (hasOptionalField(optionalFields, 'name') || isReadonlyCustomerName) {
        return VALID;
      }
      return onlyWhen('field_malaysia_customer_name') && validateMalaysianCustomerName(userInputValue);

    case 'customerEmail':
      if (hasOptionalField(optionalFields, 'email')) {
        return VALID;
      }
      return onlyWhen('field_malaysia_customer_email') && validateMalaysianCustomerEmail(userInputValue);

    default:
      return VALID;
  }
}
